/*=============================================== CardColor styles ===============================================*/

import styled from "styled-components/macro"
import { Flexbox, Radiuses, Breakpoints, Card } from "tsx-library-julseb"

const SQUARE_SIZE = 140

export const StyledCard = styled(Card)`
    flex-direction: row;
    align-items: center;

    @media ${Breakpoints.Tablet} {
        flex-direction: column;
    }
`

export const Square = styled.span`
    width: ${SQUARE_SIZE}px;
    height: ${SQUARE_SIZE}px;
    border-radius: ${Radiuses.S};
    background: var(--card-color);
    display: inline-block;
`

export const Content = styled(Flexbox)`
    --flex-row-gap: 0px;

    @media ${Breakpoints.Tablet} {
        width: 100%;
    }
`
